import { IonItem } from '@ionic/react';
import styled from 'styled-components';

export const IonItemWrapper = styled(IonItem)``;

export const TableWrapper = styled('table')`
  width: 100%;

  tbody {
    width: 100%;
  }

  .field-item.icon {
    margin-right: calc(var(--ion-margin, 16px) / 2 * -1);
  }

  .item-line {
    border-bottom-width: 0.8px;
    border-bottom-style: solid;
    border-bottom-color: #d9d9d9;
  }

  .field-item.slim {
    min-height: 0;

    &::part(native) {
      min-height: 0;
    }

    ion-label {
      margin: 0
    }
  }

  .pad {
    padding-left: 0.2rem;
  }

  .row-button {
    cursor: pointer;

    &:hover {
      background-color: var(--ion-background-color);
    }

    ion-item::part(native) {
      background-color: transparent
    }
  }

  .row-highlight {
    ion-item::part(native) {
      background-color: transparent
    }
  }
`;